import React from "react";
import Tile from "./Tile";
import "../index.css";

const GuessGrid = ({ guesses, currentGuess, getFeedback, wordLength, maxGuesses }) => {
  const rows = [];
  for (let i = 0; i < maxGuesses; i++) {
    const guess = guesses[i] || (i === guesses.length ? currentGuess : "");
    const feedback = guesses[i] ? getFeedback(guess) : [];
    const letters = [];

    for (let j = 0; j < wordLength; j++) {
      letters.push(
        <Tile key={j} letter={guess[j] || ""} status={feedback[j]} />
      );
    }
    rows.push(
      <div key={i} className="grid">
        {letters}
      </div>
    );
  }
  return <div>{rows}</div>;
};

export default GuessGrid;